"use client";

import { ImageShowcase } from "@/app/(marketing)/components/demo/showcases/ImageShowcase";
import { StarPoint } from "@/app/(marketing)/components/demo/showcases/StarPoint";
import { ButtonLink } from "@/components/buttons/ButtonLink";
import screenshot from "@/public/images/appScreenshots/stem-splitter.png";

export function StemSplitterShowcase() {
  return (
    <ImageShowcase
      screenshot={screenshot}
      headingText="Stem splitter"
      altText="Screenshot of stem splitter page"
    >
      <ul className="flex flex-col gap-y-2">
        <StarPoint>Split your audio into separate stems</StarPoint>
        <StarPoint>
          4-stem (vocals, drums, bass, other) or 2-stem (vocals, instrumental)
        </StarPoint>
      </ul>
      <ButtonLink
        external={false}
        href="/stem-splitter"
        className="mt-6 block w-fit"
      >
        Explore
      </ButtonLink>
    </ImageShowcase>
  );
}
